export default __webpack_public_path__ + "static/media/Five2.3dd55151.jpeg";